import { useEffect, useState } from "react";

const useTimer = (initialTime = 0) => {
    // Active session on sidebar use: states
    const [time, setTime] = useState(initialTime);
    const [intervalId, setIntervalId] = useState(null);
    const onSetTime = (t: number) => {
        setTime(t);
    };

    const stopTimer = () => {
        if (intervalId) {
            clearInterval(intervalId);
            setIntervalId(null);
        }
    };

    useEffect(() => {
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [intervalId]);

    const startTime = () => {
        // Clear any existing interval
        if (intervalId) {
            clearInterval(intervalId);
        }

        // Update immediately
        onSetTime(Date.now());
        console.log("data started");

        // Set new interval
        const id = setInterval(() => {
            onSetTime(Date.now());
        }, 15000); // 15 seconds

        setIntervalId(id);
    };
    return { time, intervalId, onSetTime, stopTimer, startTime };
};

export default useTimer